import { useStoreState } from "easy-peasy";

export function useFirebaseState() {
  return useStoreState((s) => s.firebase.red.firebase);
}
